// eslint-disable-next-line @typescript-eslint/no-explicit-any
const cache: Record<string, any> = {};

export function withCache<TData>(key: string, compute: () => TData): TData {
  if (key in cache) {
    return cache[key];
  }
  const result = compute();
  cache[key] = result;
  return result;
}
